import { createElement } from 'react';
import cx from 'classnames';
import { surfaces } from '../surfaces';
import type { WithSurface } from '../surfaces';

type SurfaceElement = 'aside' | 'div' | 'li' | 'main' | 'section' | 'tr';
type BaseSurfaceProps = WithSurface<React.ComponentProps<SurfaceElement>> & {
  /** Element to render, defaults to 'div' */
  as?: SurfaceElement;
};
type SurfaceProps<T extends BaseSurfaceProps> = BaseSurfaceProps & { as?: T['as'] };

export const Surface: React.FC<SurfaceProps<BaseSurfaceProps>> = ({
  ref,
  children,
  type,
  as = 'div',
  ...rest
}) => {
  const props = { ...rest, className: cx(rest.className, surfaces[type]), ref };
  return createElement(as, props as React.HTMLProps<HTMLElement>, children);
};
